import { AfterViewInit, Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { CommonUtils } from '../util/common-utils';
import { DateUtils } from '../util/date-utils';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { UserAccountService } from '../user-account.service';
import { DeviceDetailsService } from '../device-details.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
declare var setNgxSmartModalOpenStateClosed: any;
@Component({
    selector: 'app-help-popup',
    templateUrl: './help-popup.component.html',
    styleUrls: ['./help-popup.component.scss'],
    standalone: false
})
export class HelpPopupComponent implements OnInit, AfterViewInit, OnDestroy {
  searchPopClicked = true;
  njoySpecificBuild: boolean;
  isModalOpen = false;

  // Agent session state
  hasActiveSession = false;
  sessionAgentName = '';
  sessionTimer = '';
  private sessionExpiresAt = 0;
  private sessionRequestId = '';
  private timerInterval: any;
  private sessionStatusPollInterval: any;
  private sessionSub: Subscription;

  constructor(public ngxSmartModalService: NgxSmartModalService,
    private deviceDetailsService: DeviceDetailsService,
    public userAccountInfoService: UserAccountService,
    private toastr: ToastrService) {
    this.njoySpecificBuild = this.userAccountInfoService.isItNjoyBuild();
  }
  isMobile = false;
  isMobile1 = false;
  ngOnInit() {
    this.deviceDetailsService.isMobile().subscribe(isMobile => {
      this.isMobile = isMobile;
    });
    this.deviceDetailsService.isMobile2().subscribe(isMobile => {
      this.isMobile1 = isMobile;
    });
    this.sessionSub = this.userAccountInfoService.approvedSession$.subscribe(session => {
      if (session) {
        this.hasActiveSession = true;
        this.sessionAgentName = session.agentName;
        this.sessionExpiresAt = session.expiresAt;
        this.sessionRequestId = session.requestId;
        this.startTimer();
        this.startSessionStatusPoll(session.requestId);
      } else {
        this.hasActiveSession = false;
        this.sessionAgentName = '';
        this.sessionTimer = '';
        this.sessionRequestId = '';
        this.stopTimer();
        this.stopSessionStatusPoll();
        // After Angular removes the session card via *ngIf, clear any retained height
        setTimeout(() => {
          const el = document.querySelector('.modalAirportFilterInfo') as HTMLElement;
          if (el) { el.style.height = ''; void el.getBoundingClientRect(); }
        }, 0);
      }
    });
  }

  private startTimer() {
    this.stopTimer();
    this.updateTimer();
    this.timerInterval = setInterval(() => this.updateTimer(), 1000);
  }

  private updateTimer() {
    const remaining = Math.max(0, this.sessionExpiresAt - Date.now());
    this.sessionTimer = DateUtils.formatCountdown(remaining / 1000);
    if (remaining === 0) {
      this.userAccountInfoService.approvedSession$.next(null);
    }
  }

  private stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  private startSessionStatusPoll(requestId: string) {
    this.stopSessionStatusPoll();
    this.sessionStatusPollInterval = setInterval(() => {
      this.userAccountInfoService.checkUpgradeStatus(requestId).subscribe({
        next: (resp: any) => {
          if (resp && resp.status === 'success') {
            if (resp.data?.transferred && resp.data?.requestId && resp.data.requestId !== requestId) {
              // Session was transferred to a new agent — update the active session seamlessly
              this.stopSessionStatusPoll();
              this.userAccountInfoService.approvedSession$.next({
                requestId: resp.data.requestId,
                agentName: resp.data.agentName || '',
                agentId: resp.data.agentId || '',
                expiresAt: resp.data.expiresAt || this.sessionExpiresAt
              });
            } else if (resp.data?.approved === false) {
              this.stopSessionStatusPoll();
              this.userAccountInfoService.approvedSession$.next(null);
            }
          }
        },
        error: () => {}
      });
    }, 5000);
  }

  private stopSessionStatusPoll() {
    if (this.sessionStatusPollInterval) {
      clearInterval(this.sessionStatusPollInterval);
      this.sessionStatusPollInterval = null;
    }
  }

  endAgentSession() {
    if (!this.sessionRequestId) {
      this.userAccountInfoService.approvedSession$.next(null);
      this.onSmartModelCancel('helpModal');
      return;
    }
    this.userAccountInfoService.revokeAgentSession(this.sessionRequestId).subscribe({
      next: () => {
        this.userAccountInfoService.approvedSession$.next(null);
        this.onSmartModelCancel('helpModal');
        this.toastr.info('Agent session has been ended.', 'Session Ended');
      },
      error: () => {
        this.userAccountInfoService.approvedSession$.next(null);
        this.onSmartModelCancel('helpModal');
        this.toastr.info('Agent session has been ended.', 'Session Ended');
      }
    });
  }

  ngOnDestroy() {
    this.stopTimer();
    this.stopSessionStatusPoll();
    if (this.sessionSub) this.sessionSub.unsubscribe();
  }
  ngAfterViewInit() {
  }
  openHelpPopup(){
    let modals = this.ngxSmartModalService.getOpenedModals();
    for (let index = 0; index < modals.length; index++) {
      setNgxSmartModalOpenStateClosed(modals[index].id);
    }
    this.ngxSmartModalService.getModal('helpModal').open();
    document.body.style.overflow = 'hidden';
    this.isModalOpen = true;
  }
  isuserHascard(): boolean {
    return this.userAccountInfoService.userhascard;
  }
  handleModalEvents(eventName: string, currentModalId: string) {
    if (eventName === 'onClose' || eventName === 'onDismiss' || eventName === 'onDismissFinished') {
      this.isModalOpen = false;
    }
    CommonUtils.handleModalEvents(this.ngxSmartModalService, eventName, currentModalId);
  }
  isDashboardPage() {
    if(this.userAccountInfoService.getCurrentRouterPath()){
    return this.userAccountInfoService.getCurrentRouterPath().indexOf('admin') === 1;
  }
  }
  changeStyle() {

      if(this.isDashboardPage()){
      return { 'background':'#F5F5FA' }
      }
      else{
        return { 'background':'#FFF' }
      }

  }
  onSmartModelCancel(modelName: string) {
    const el = $('.modalAirportFilterInfo');
    el.slideUp();
    $('#helpPoupupWrapper').hide();
    let modals = this.ngxSmartModalService.getOpenedModals();
    for (let index = 0; index < modals.length; index++) {
      setNgxSmartModalOpenStateClosed(modals[index].id);
    }
    this.isModalOpen = false;
    document.body.style.overflow = '';
    this.ngxSmartModalService.getModal(modelName).close();
  }

  @HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent) {
  const modal = document.querySelector('.modalAirportFilterInfo');
  const helpBtn = document.querySelector('.help-button');

  if (!modal || !this.isModalOpen) return;

  const clickedInsideModal = modal.contains(event.target as Node);
  const clickedHelpButton = helpBtn?.contains(event.target as Node);

  if (!clickedInsideModal && !clickedHelpButton) {
    const checkModal = document.querySelector('#helpPoupupWrapper .nsm-overlay-open');
    if(checkModal){
     this.onSmartModelCancel('helpModal');
    };
  };
}




}
